import { FC } from "react";
import _ from "lodash";
import { classNames } from "utils";
import { Switch } from "@headlessui/react";

interface SwitchInputProps {
  id: string;
  label?: string;
  description?: string;
  disabled?: boolean;
  required?: boolean;
  setFieldValue: (field: string, value: any) => void;
  values: any;
  handleChange: any;
  handleBlur: any;
  errors?: any;
  touched?: any;
  labelHidden?: boolean;
}

const SwitchInput: FC<SwitchInputProps> = ({ id, values, setFieldValue, label, description, errors, touched, required, labelHidden, disabled }) => {

  return (
    <>
      <Switch.Group as="div">
        {
          !labelHidden && Boolean(label) && (
            <span className="flex flex-grow flex-col">
              <Switch.Label
                as="span"
                className="text-sm font-medium text-gray-900"
                passive
              >
                {label}
              </Switch.Label>
            </span>
          )
        }
        <div className="flex items-center gap-2 justify-between mt-1  h-[38px]">
          {
            Boolean(description) && (
              <Switch.Description
                as="span"
                className="text-sm text-gray-500"
              >
                {description}
              </Switch.Description>
            )
          }
          <Switch
            checked={values[id]}
            aria-required={required ? "true" : "false"}
            disabled={disabled}
            onChange={(val: boolean) => setFieldValue(id, val)}
            className={classNames(
              values[id]
                ? "bg-primary-600"
                : "bg-gray-200",
              disabled ? "cursor-not-allowed bg-gray-100" : "",
              "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2",
            )}
          >
            <span
              aria-hidden="true"
              className={classNames(
                values[id]
                  ? "translate-x-5"
                  : "translate-x-0",
                "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
              )}
            />
          </Switch>
        </div>
      </Switch.Group>
      {_.get(errors, id) && _.get(touched, id) ? (
        <p className="mt-2 text-sm text-red-600" id={`${id}-error`}>
          {_.get(errors, id)}
        </p>) : null
      }
    </>
  );
};

export default SwitchInput;